// Hook odpowiedzialny za pobranie listy produktw z typu subelementu strony głównej

import { axios } from 'api';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IProductListItem
} from 'api/types';

// parametry requestu do api
type IRequest = IPaginationRequest & {
  scopes?: string;
  productIds?: string;
};

// typ zwracanych danych
type IResponse = IPaginationResponse<IProductListItem>;

const getHomeSubelementItems = (subelementType: number, params?: IRequest): Promise<IResponse> =>
  axios.get(`/home/subelements/${subelementType}`, { params });

export const useGetHomeSubelementItems = (
  subelementType: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['home-subelement-items', subelementType, params],
    () => getHomeSubelementItems(subelementType, params),
    options
  );

export const useGetHomeSubelementItemsMutation = (
  subelementType: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => getHomeSubelementItems(subelementType, data), options);
